<template>
  <div>
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="mx-auto" outlined >
          <div class="v-lazy pa-5">
            <v-row>
              <v-col cols="6" class="text-h4">{{ $t("menu.aboutus") }}</v-col>
            </v-row>
          </div>
        </v-card>
        <v-row>
          <v-col cols="6">
            <upload-card ref="UploadCard"></upload-card>
          </v-col>
          <v-col cols="6">
            <text-form ref="TextCard"></text-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <topic-form ref="TopicForm"></topic-form>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import UploadCard from './uploadimg';
  import TextForm from './text-form';
  import TopicForm from './three-topic-form';
  export default {
    components: {
      UploadCard,
      TextForm,
      TopicForm
    },
    data() {
      return {
        
      };
    },

    methods: {
      GetData(){
        this.$store.commit('set_overlay',true);
         this.req.get(this.$store.getters.base_api + 'get-about-us/'+this.$store.getters.authen.locale).then(response=>{
            this.$refs.UploadCard.src = response.data.img.src;

            this.$refs.TextCard.text = response.data.text.detail;
            this.$refs.TextCard.$refs.answersit.content = response.data.text.detail;
            this.$refs.TopicForm.value = response.data.core.detail;
            this.$refs.TopicForm.vision = response.data.vision.detail;
            this.$refs.TopicForm.mission = response.data.mission.detail;
          this.$store.commit('set_overlay',false);
        }).catch(error => {
          this.$store.commit('set_overlay',false);
        });
      },
  },
  mounted() {
    this.req = this.$store.getters.req;
    this.GetData();
  },



};
</script>
